import React from 'react'
import {
  Accordion as AccordionMUI,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import IsValidCheck from 'components/icons/valid-form-check.svg'
import sx from './styles'

const Accordion = (props) => {
  const {
    title,
    children,
    icon,
    isValid = false,
    isExpanded = false,
    onChangeExpanded,
    setTitleBlackColor = false,
    IsValidIcon = null,
    sx: sxProp,
    className,
  } = props
  const formTitleColor = setTitleBlackColor ? sx.formTitleValid : sx.formTitleInvalid

  const validIcon = IsValidIcon || <IsValidCheck />

  return (
    <AccordionMUI
      mb={2}
      expanded={isExpanded}
      onChange={onChangeExpanded}
      sx={{ ...sx.root, ...sxProp }}
      className={className}
    // {...props}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
      >
        <Box sx={sx.accordionContent}>
          {isValid ? validIcon : icon}
          <Typography
            variant="h5"
            sx={{ ...sx.formTitle, ...formTitleColor }}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={sx.accordionDetails}>{children}</AccordionDetails>
    </AccordionMUI>
  )
}

export default Accordion
